import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import EmptyData from '@hellodarwin/icons/dist/icons/EmptyData';
import { useTheme } from 'styled-components';
import { EmptyStateActions } from './styles';
const EmptyState = ({ title, description, cta }) => {
    const theme = useTheme();
    return (_jsxs(EmptyStateActions, { "$gap": theme.spacing.xs, children: [_jsx(EmptyData, { size: 64, color: theme.colors.grey_2, style: { marginBlockEnd: theme.spacing.sm } }), _jsx(Typography, { elementTheme: "subtitle1", textAlign: "center", children: title }), _jsx(Typography, { textAlign: "center", color: theme.colors.grey_2, children: description }), !!cta && (_jsx(Button, Object.assign({}, cta, { style: Object.assign(Object.assign({}, cta.style), { marginTop: theme.spacing.sm }) })))] }));
};
export default EmptyState;
